export default "__VITE_ASSET__CpEsT0qR__"